import { z } from 'zod';

import { CustomError } from '@/types';

const apiErrorSchema = z.object({
  status: z.union([z.number(), z.string()]).optional(),
  meta: z.object({ refreshTokenError: z.boolean().optional() }).optional(),
});

export const isApiError = (error: unknown): error is CustomError => {
  const result = apiErrorSchema.safeParse(error);
  return (
    result.success &&
    !!result.data.status &&
    !result.data.meta?.refreshTokenError
  );
};
